export default "__VITE_ASSET__BCWDaWHW__"